<template>
  <div>
    <b-modal
      title="會員順延名單"
      size="lg"
      centered
      hide-footer
      header-class="head-modal"
      v-model="modalShow"
    >
      <div class="contract-data">
        <div>會員編號：{{ data.number }}</div>
        <div>姓名：{{ data.member_name }}</div>
        <div>入會日：{{ convertRocDate(data.join_date) }}</div>
      </div>

      <tables-page
        :tableData="table_data"
        :tableFields="table_fields"
      >
        <template #cell(dead_at)="row">
          {{ convertRocDate(row.item.dead_at) }}
        </template>

        <template #cell(accept_at)="row">
          {{ convertRocDate(row.item.accept_at) }}
        </template>

        <template #cell(member_ID_number)="row">
          {{ isMaskData ? maskData(row.item.member_ID_number, 'ID') : row.item.member_ID_number }}
        </template>

        <template #cell(member_name)="row">
          {{ isMaskData ? maskData(row.item.member_name, 'name') : row.item.member_name }}
        </template>
      </tables-page>

      <b-overlay :show="status.isLoading" no-wrap></b-overlay>
    </b-modal>
  </div>
</template>

<script>
import TablesPage from "@/components/layouts/TablesPage";
import contractApi from "@/models/API/contractApi";
import { countNoNum, convertRocDate, maskData } from "@/models/HELPERS/common.js";

export default {
  name: 'MemberPostponementListModal',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      required: false,
      default: false
    },
    data: {
      type: Object,
      required: false,
      default: () => {}
    },
    isMaskData: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    TablesPage
  },
  data () {
    return {
      status: {
        isLoading: false
      },
      table_fields: [
        {
          key: "no",
          label: "No",
        },
        {
          key: "plan",
          label: "組別",
        },
        {
          key: "number",
          label: "契約編號",
        },
        {
          key: "member_ID_number",
          label: "身分證",
        },
        {
          key: "member_name",
          label: "姓名",
        },
        {
          key: "dead_at",
          label: "身故日期",
        },
        {
          key: "accept_at",
          label: "受理日期",
        }
      ],
      page: {},
      table_data: [],
    }
  },
  computed: {
    modalShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('change', value);
      }
    },
  },
  watch: {
    show: {
      handler(newValue, oldValue) {
        if (newValue) this.getDeferred();
      },
      immediate: false
    }
  },
  mounted() {
    this.contractApi = new contractApi();
    this.load();
  },
  methods: {
    // 首次載入讀取
    load() {
      this.page = Object.assign({}, this.contractApi.page);
    },
    convertRocDate,
    maskData,
    // 查詢遞延
    getDeferred() {
      this.status.isLoading = true;

      const params = {
        'member_id': this.data.id,
        'PageSize': 99999,
        'PageIndex': 1,
      };

      this.contractApi.getDeferred((response) => {
        const res = response.data;

        this.page.totalCount = res.total; // 總筆數
        this.table_data = res.data.map((item, index) => {
          return {
            ...item,
            no: countNoNum(this.page, index)
          }
        });

        this.status.isLoading = false;
      }, params, false)
    },
  }
}
</script>

<style lang="scss" scoped>
.contract-data {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/common/Modal/MemberPostponementListModal.vue